<div class="filters" [class.no-search]="!searchKey">
  <div class="results">{{ resultsLabel }}</div>
  <button *ngIf="secondaryButtonAction" mat-raised-button type="button" (click)="secondaryButtonAction()">
    {{ secondaryButtonKey | translate }}
  </button>
  <span class="separator"></span>

  <button
    *ngIf="primaryButtonAction"
    mat-raised-button
    color="primary"
    type="button"
    (click)="primaryButtonAction()"
    [disabled]="primaryButtonDisabled">
    {{ primaryButtonKey | translate }}
  </button>
  <mat-form-field appearance="outline" class="shrink" *ngIf="searchKey">
    <mat-label>{{ searchKey | translate }}</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input id="input-search-bar" autocomplete="off" type="text" [formControl]="searchCtrl" matInput />
    <mat-error *ngIf="searchCtrl.hasError('minlength')">
      {{ 'search-bar/message/min-length' | translate }}
    </mat-error>
    <mat-icon role="button" *ngIf="searchCtrl?.value" (click)="clearSearch()" matSuffix>close</mat-icon>
  </mat-form-field>

  <div id="clear-filters" *ngIf="searchBarService.hasFilters" (click)="clearFilters()">
    <div class="clear-filters-icon"></div>
    {{ 'search-bar/uncheck-filters' | translate }}
  </div>
</div>
